(ns hai.home.desktop.mini-apps.tasks
  "My Tasks mini-app card: the same task data as the full Tasks page, grouped
   into collapsible Now / Next / Later sections. The header's looking glass
   opens the universal bar; the ＋ swaps the card into Add-a-task mode — the
   header retitles and the body becomes the title form ([[hai.tasks.form]]);
   the title links to the full Tasks page. The task rows live here since the
   dashboard is their only home."
  (:require
   [hai.entity.data :as entity-data]
   [hai.mini-apps.frame :as mini-apps]
   [hai.tasks.assignee-picker :as assignee-picker]
   [hai.tasks.card :as task-card]
   [hai.tasks.data :as data]
   [hai.tasks.form :as form]
   [hai.tasks.header :as header]
   [hai.tasks.mini-app :as tasks-mini-app]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.routing :as routing]
   [hai.web-app.universal-bar :as universal-bar]
   [reagent.core :as r]))

(def ^:private close-icon (icons/mui-icon :outlined :close))

(defn- section-view [{:keys [label tasks open? on-toggle]}]
  [mini-apps/section-view
   {:label label :item-count (count tasks) :open? open? :on-toggle on-toggle}
   (when (seq tasks)
     (into [:div.section-tasks]
           (map (fn [task]
                  ^{:key (:task/uuid task)}
                  [task-card/task-row-component task
                   {:hover-actions? true
                    :show-hint? true
                    :on-open-entity entity-data/open-entity}]))
           tasks))])

(defn panel []
  (r/with-let [!adding? (r/atom false)
               !open (r/atom #{:now})
               toggle-section (fn [id]
                                (swap! !open (fn [open]
                                               (if (contains? open id)
                                                 (disj open id)
                                                 (conj open id)))))]
    (let [buckets @(<s [::data/buckets])
          loaded? @(<s [::data/loaded?])
          adding? @!adding?
          open @!open
          total (reduce + (map count (vals buckets)))]
      (if adding?
        [tasks-mini-app/card
         [header/bar {:title "Add a task"}
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Cancel"
            :title "Cancel"
            :on-click #(reset! !adding? false)}
           [close-icon {:size 18}]]]
         [form/task-form {:on-save (fn [staged]
                                     (>e [::data/create staged])
                                     (swap! !open conj (data/staged-bucket staged)))
                          :on-close #(reset! !adding? false)
                          :show-hint? true
                          :render-assignee-picker
                          (fn [{:keys [on-pick trigger]}]
                            [assignee-picker/component
                             {:editable? true
                              :on-pick on-pick
                              :label "Assign"
                              :trigger trigger}])}]]
        [tasks-mini-app/card
         [header/bar
          {:title "My Tasks"
           :href (routing/href :tasks/view)
           :target routing/link-target}
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Search tasks"
            :title "Search tasks"
            :on-click #(>e [::universal-bar/open])}
           [icons/outlined-search {:size 18}]]
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Add a task"
            :title "Add a task"
            :on-click #(reset! !adding? true)}
           [icons/plus {:size 16}]]]
         (cond
           (not loaded?) nil
           (zero? total) [:div.app-placeholder "Nothing yet — add your first task above."]
           :else
           (into [:div.task-sections]
                 (map (fn [{:keys [id label]}]
                        ^{:key id}
                        [section-view {:label label
                                       :tasks (get buckets id)
                                       :open? (contains? open id)
                                       :on-toggle #(toggle-section id)}]))
                 data/bucket-tabs))]))))
